import './App.less';
import 'moment/locale/zh-cn';
import zhCN from 'antd/es/locale/zh_CN';
import { ConfigProvider } from 'antd';
import MyRouter from './router';

function App() {
	return (
		<ConfigProvider locale={zhCN}>
			<MyRouter />
			{/* <Suspense fallback={
				<LuckProgress>
					<LuckLoading />
				</LuckProgress>
			}> */}
				{/* {useRoutes(router)} */}
				{/* <RouterProvider
					router={router}
				/> */}
			{/* </Suspense> */}
			{/* <RouterProvider
				router={router}
				fallbackElement={
					<LuckProgress>
						<LuckLoading />
					</LuckProgress>
				}
			/> */}
		</ConfigProvider>
	);
}

export default App;
